import React from 'react'
import { User } from '../../../types/models/user'
import { AdminAccountCardStyled } from './styles'

// Add SVG icon for admin
const AdminIcon = () => (
  <svg width="50" height="50" viewBox="0 0 24 24" fill="currentColor" style={{ color: '#ffffff' }}>
    <path d="M12 14c-2.67 0-8 1.33-8 4v2h16v-2c0-2.67-5.33-4-8-4m0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4m0-10c3.31 0 6 2.69 6 6 0 3.32-2.69 6-6 6s-6-2.68-6-6c0-3.31 2.69-6 6-6Z" />
  </svg>
)

interface AdminAccountCardProps {
  currentUser: User | undefined
  formatDate: (date: string) => string
}

const AdminAccountCard: React.FC<AdminAccountCardProps> = ({ currentUser, formatDate }) => {
  if (!currentUser || currentUser.username !== 'admin') return null

  return (
    <AdminAccountCardStyled>
      <div className="card-header">
        <h4 className="mb-0" style={{ color: '#ffffff' }}>
          System Administrator
        </h4>
      </div>
      <div className="card-body">
        <div key={currentUser.id}>
          <div className="text-center mb-4">
            <div className="admin-avatar">
              <AdminIcon />
            </div>
            <div className="admin-name">{`${currentUser.first_name} ${currentUser.last_name}`}</div>
            <div className="admin-username">{currentUser.username}</div>
            <span className="admin-badge">System Account</span>
          </div>

          <div className="admin-info">
            <div className="info-item">
              <span className="info-label">Email:</span>
              <span className="info-value">{currentUser.email}</span>
            </div>
            <div className="info-item">
              <span className="info-label">Last Login:</span>
              <span className="info-value">{formatDate(currentUser.last_login || '')}</span>
            </div>
          </div>
        </div>
      </div>
    </AdminAccountCardStyled>
  )
}

export default AdminAccountCard
